//root


export const fromDataTables = resource => `dataTables/${resource}`

//booking
export const dataTables = (state) => state.dataTables
export const dataTablesBookingsList = (state) => dataTables(state).bookingList
export const dataTablesLoading = (state) => dataTables(state).loading
export const dataTablesBooking = (state) => dataTables(state).booking